import styled from '@emotion/styled'
import { Button, ButtonProps } from '@mui/material'

interface GradientFilledButtonProps extends ButtonProps {
    isThisSelected?: boolean;
    radius?: string;
}

const GradientFilledButton = styled(Button)<GradientFilledButtonProps>(({ isThisSelected = false, radius = '16px' }) => ({
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'flex-start',
    paddingX: 2,
    color: 'var(--text-dark)',
    textTransform: 'none',
    borderRadius: radius,
    border: '2px solid #015699',
    background: 'rgba(152, 214, 229, 0.50)',
    boxShadow: '0px 0px 9px 0px rgba(18, 174, 181, 0.86) inset',
}))

export default GradientFilledButton